export default {
  phone: /^\+((\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
  text: /^[A-z]{1,}$/,
};


// WEBPACK FOOTER //
// ./src/shared/utils/Validator.js